export const Types = {
  SAVE_LIST_BANK : 'SAVE_LIST_BANK',
  SAVE_LIST_BANK_OF_USER : 'SAVE_LIST_BANK_OF_USER',
}
